import { render, staticRenderFns } from "./RequestForms.vue?vue&type=template&id=2f5257f0&scoped=true"
import script from "./RequestForms.vue?vue&type=script&lang=js"
export * from "./RequestForms.vue?vue&type=script&lang=js"
import style0 from "./RequestForms.vue?vue&type=style&index=0&id=2f5257f0&prod&lang=css"
import style1 from "./RequestForms.vue?vue&type=style&index=1&id=2f5257f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5257f0",
  null
  
)

export default component.exports